import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type FieldInfo = {
  isOnEdit: boolean
  valueEdited: string | number
}

export type BoutiqueState = {
  emailField: FieldInfo
  siretNumberField: FieldInfo
  sirenNumberField: FieldInfo
  fidelityNumberField: FieldInfo
  shopNameField: FieldInfo
  addressField: FieldInfo
}

const initialState: BoutiqueState = {
  emailField: { isOnEdit: false, valueEdited: "" },
  siretNumberField: { isOnEdit: false, valueEdited: "" },
  sirenNumberField: { isOnEdit: false, valueEdited: "" },
  fidelityNumberField: { isOnEdit: false, valueEdited: "" },
  shopNameField: { isOnEdit: false, valueEdited: "" },
  addressField: { isOnEdit: false, valueEdited: "" },
}

export const boutiqueSlice = createSlice({
  name: "boutique",
  initialState,
  reducers: {
    setEmailField: (state, action: PayloadAction<FieldInfo>) => {
      state.emailField = action.payload
    },
    setSiretNumberField: (state, action: PayloadAction<FieldInfo>) => {
      state.siretNumberField = action.payload
    },
    setSirenNumberField: (state, action: PayloadAction<FieldInfo>) => {
      state.sirenNumberField = action.payload
    },
    setFidelityNumberField: (state, action: PayloadAction<FieldInfo>) => {
      state.fidelityNumberField = action.payload
    },
    setShopNameField: (state, action: PayloadAction<FieldInfo>) => {
      state.shopNameField = action.payload
    },
    setAddressField: (state, action: PayloadAction<FieldInfo>) => {
      state.addressField = action.payload
    },
  },
})

export const {
  setEmailField,
  setSiretNumberField,
  setSirenNumberField,
  setFidelityNumberField,
  setShopNameField,
  setAddressField,
} = boutiqueSlice.actions
export default boutiqueSlice.reducer
